// Darshan temple mark: shikhara with a pennant flag (dhwaja) as in the brand logo. `simple` drops the
// doorway and thickens strokes so the silhouette still reads at small sizes (sidebar rail, 48px launcher).
export function TempleMark({ size = 32, simple = false, label }: { size?: number; simple?: boolean; label?: string }) {
  const stroke = simple ? 2.4 : 2.2;
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" role={label ? "img" : undefined} aria-label={label} aria-hidden={label ? undefined : true}>
      {/* dhwaja (flag on the shikhara) */}
      <path d="M16 2v5.5" stroke="#ff7f22" strokeWidth={simple ? 2 : 1.6} strokeLinecap="round" />
      <path d="M16 1.6l5.4 1.9-5.4 1.9z" fill="#ff7f22" />
      <path d="M16 7.5l-5.2 8h10.4z" fill="#ff7f22" />
      <path d="M8 28V18.2l8-2.7 8 2.7V28" stroke="#ff7f22" strokeWidth={stroke} strokeLinejoin="round" />
      {!simple && <path d="M13.5 28v-4.6a2.5 2.5 0 015 0V28" stroke="#ffb27a" strokeWidth="2" />}
      <path d="M5 28h22" stroke="#ff7f22" strokeWidth={stroke} strokeLinecap="round" />
    </svg>
  );
}

export function Wordmark({ className }: { className?: string }) {
  return <span className={className ? `wordmark ${className}` : "wordmark"} lang="hi">दर्शन</span>;
}
